export default __webpack_public_path__ + "static/1-a069ac561efdd381098e5b55102384de.png";